export const environment = {
    production: false,
    intercom: "saj7fczk",
    api_url: "https://api-staging.axiocap.com/api/v1",
    auth0_domain: "auth-staging.axiocap.com",
    auth0_client_id: "bSQEPwhX29lAOcTzXNBUP6W9TXAqPbhK",
    auth0_redirect_url: "https://shareholder-staging.axiocap.com/login",
    auth0_audience: "https://api-staging.axiocap.com/api/v1/"
};
